import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppleLogo from '~/images/Ecosystem/AppleLogo.svg';

const AppStoreButton: React.FC<{ url: string }> = ({ url }) => {
  const { t } = useTranslation('onboarding');

  return (
    <Link prefetch={false} legacyBehavior passHref href={url}>
      <a
        target='_blank'
        className='flex h-fit min-h-[43px] w-full min-w-[110px] max-w-[170px] items-center gap-2 rounded-[0.8rem] border-xs border-grey-600 bg-text-default px-20 py-2 desktop:gap-1 desktop:py-1 desktop:px-2'
      >
        <span className='text-24'>
          <AppleLogo />
        </span>
        <div className='flex flex-col text-white'>
          <span className='text-8'>{t('download-on')}</span>
          <span className='text-14 font-medium'>{t('app-store')}</span>
        </div>
      </a>
    </Link>
  );
};

export { AppStoreButton };
